import { createFileRoute } from '@tanstack/react-router';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { createMigrationRouteGuard } from '@/utils/route-guards/migration-guard';

export const Route = createFileRoute('/$org/$agent/sensor-calibration')({
  beforeLoad: async (ctx) => {
    await createMigrationRouteGuard(AtlasRouteIds.SensorCalibration)(ctx);
  },
});
